module.exports = __webpack_public_path__ + "static/media/flame.941c63eb.png";